// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamToolsLabel__isFilteredIcon___pF7FT {
    opacity: 0.5;
    position: relative;
    bottom: 1px;
    color: yellow;
    padding-left: 9px;
    font-size: 10px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"isFilteredIcon": `DreamToolsLabel__isFilteredIcon___pF7FT`
};
module.exports = ___CSS_LOADER_EXPORT___;
